// src/routes/admin/AdminRoutes.js
import React, { lazy } from "react";
import ProtectedRoute from '../ProtectedRoute';

const AdminDashboard = lazy(() => import("../../components/admin/AdminDashboard"));
const CollectionViewer = lazy(() => import("../../components/admin/collections/CollectionViewer"));
const SecurityGuide = lazy(() => import("../../components/admin/SecurityGuide"));

const AdminRoutes = [
  {
    path: "admin/security",
    element: (
      <ProtectedRoute requiredPermission="manage_security">
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/security/guide",
    element: (
      <ProtectedRoute requiredPermission="manage_security">
        <SecurityGuide />
      </ProtectedRoute>
    ),
  },
  {
    path: "admin/collections",
    element: (
      <ProtectedRoute requiredPermission="view_all_database">
        <CollectionViewer />
      </ProtectedRoute>
    ),
  },
];

export default AdminRoutes;